import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const { auth, logout } = useAuth();
  const navigate = useNavigate();
  console.log(auth);

  const handleCreateArticle = () => {
    navigate("/dashboard/create-article");
  };

  const handleEditArticle = () => {
    navigate("/dashboard/edit-article");
  };

  const handleDeleteArticle = () => {
    navigate("/dashboard/delete-article");
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>ようこそ、{auth.user} さん</h1>
      <div style={styles.buttonContainer}>

        <button onClick={handleCreateArticle} style={styles.button}>
          記事を作成
        </button>

        <button onClick={handleEditArticle} style={styles.button}>
          記事を編集
        </button>

        <button onClick={handleDeleteArticle} style={styles.button}>
          記事を削除
        </button>

        <button onClick={logout} style={styles.logoutBtn}>
          ログアウト
        </button>

      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "600px",
    margin: "auto",
    padding: "20px",
    textAlign: "center",
    background: "#f8f9fa",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)"
  },
  title: {
    fontSize: "24px",
    color: "#333",
    marginBottom: "20px"
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px"
  },
  button: {
    width: "200px",
    padding: "10px 20px",
    background: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    textAlign: "center",
    transition: "0.3s",
    fontSize: "16px"
  },
  logoutBtn: {
    width: "200px",
    padding: "10px 20px",
    background: "#dc3545",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    textAlign: "center",
    transition: "0.3s",
    fontSize: "16px"
  }
};

export default Dashboard;